import axios from 'axios';
import axiosRetry from './utils/axios/retry';

const HTTP_STATUS_TEMPORARY_REDIRECT = 307;
const HTTP_STATUS_PERMANENT_REDIRECT = 308;

export default class BaseService {
  timeout = 10000; // in miliseconds
  retry = 0;
  maxRedirects = 5;

  logger = () => {}; // eslint-disable-line no-empty-function

  fetch(config) {
    return this._validateAndExecuteFetch(config);
  }

  validate(config) {
    // throw error if you want to add validation
  }

  handleSuccess(config, response) {
    return response.data;
  }

  handleError(config, error) {
    const { url } = config;
    // format message so dev can react accordingly
    if (error.response) {
      throw new Error(`Fetching ${url} failed with status code ${error.response.status}`);
    }

    // Something happened in setting up the request that triggered an Error
    throw new Error(`Network error when requesting ${url}: ${error.message}`);
  }

  handleRedirect(config, error) {
    const newPath = error.response.headers.location;
    const newConfig = {
      ...config,
      maxRedirects: config.maxRedirects - 1,
      path: newPath,
    };
    return this._validateAndExecuteFetch(newConfig);
  }

  isHandleRedirect(config, response) {
    return config.maxRedirects > 0;
  }

  isRedirectResponse(response) {
    if (!response) return false;
    return [HTTP_STATUS_PERMANENT_REDIRECT, HTTP_STATUS_TEMPORARY_REDIRECT].some(status => status === response.status);
  }

  /**
   * @param {string} path - postfix url
   * @returns {string} - full path url
   */
  getFullUrl(path) {
    return this.getBaseUrl() + path;
  }

  getBaseUrl() {
    return 'http://localhost';
  }

  _getConfig(config = {}) {
    const baseUrl = this.getBaseUrl();
    return {
      timeout: this.timeout,
      retry: this.retry,
      maxRedirects: this.maxRedirects,
      ...config,
      baseUrl,
      url: baseUrl + config.path,
    };
  }

  _validateAndExecuteFetch(_config) {
    const config = this._getConfig(_config);
    this.validate(config); // for validation purpose
    return this._executeFetch(config);
  }

  _executeFetch(config = {}) {
    if (config.retry) {
      axiosRetry(axios, config, error => !(this.isRedirectResponse(error.response) && this.isHandleRedirect(config)));
    }
    this.logger('[FETCH]');
    this.logger(config);
    return axios(config)
      .then(response => {
        this.logger('[FETCH] SUCCESS');
        this.logger(response);
        return this.handleSuccess(config, response);
      })
      .catch(error => {
        this.logger('[FETCH] ERROR');
        this.logger(error);
        if (error && this.isRedirectResponse(error.response) && this.isHandleRedirect(config)) {
          return this.handleRedirect(config, error);
        }
        return this.handleError(config, error);
      });
  }
}
